import axios from 'axios'

export function toError(err: unknown): Error {
  if (err instanceof Error) {
    return err
  }
  if (typeof err === 'string') {
    return new Error(err)
  }
  if (axios.isAxiosError(err) && err.response) {
    return new Error(err.response.data.message)
  }
  return new Error('An unknown error occurred')
}

/**
 * Logs the error and performs optional additional logic.
 */
export function handleError(error: Error): void {
  // Log the error (can be enhanced to log to a monitoring service)
  console.error('An error occurred:', error.message)

  // Optional: Add additional error handling logic here
  // Example: Show an alert or notification to the user
  // alert(`An error occurred: ${error.message}`);
}